export default __webpack_public_path__ + "static/media/tooltip.79694b42.svg";